const proxySelector = '[data-add-to-cart-proxy]';
const addToCartSelector = 'product-form-component [data-testid="standalone-add-to-cart"]';

let syncFrame;

function getAddToCartButton() {
  return document.querySelector(addToCartSelector);
}

function syncProxyButton(proxyButton) {
  const addToCartButton = getAddToCartButton();
  proxyButton.disabled = !addToCartButton || addToCartButton.disabled;
}

function syncProxyButtons() {
  syncFrame = undefined;
  document.querySelectorAll(proxySelector).forEach(syncProxyButton);
}

function scheduleSync() {
  if (syncFrame) return;
  syncFrame = requestAnimationFrame(syncProxyButtons);
}

function handleProxyClick(event) {
  const proxyButton = event.target.closest(proxySelector);
  if (!proxyButton) return;

  const addToCartButton = getAddToCartButton();
  if (!addToCartButton || addToCartButton.disabled) {
    syncProxyButton(proxyButton);
    return;
  }

  addToCartButton.click();
}

document.addEventListener('click', handleProxyClick);

new MutationObserver(scheduleSync).observe(document.documentElement, {
  attributes: true,
  attributeFilter: ['disabled', 'data-limit-disabled'],
  childList: true,
  subtree: true,
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncProxyButtons, { once: true });
} else {
  syncProxyButtons();
}
